export enum NativeCrossOrigin {
	ANONYMOUS = 'anonymous',
	USE_CREDENTIALS = 'use-credentials'
}
